import { MessageScreens } from 'shared/enum';

export interface IMessageCommonInterface {
	mobileVisibleScreen: MessageScreens;
}

export const messageCommonState: IMessageCommonInterface = {
	mobileVisibleScreen: MessageScreens.LEFT,
};
